// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h2[data-v-80cc4fc8] {\n  margin-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
